//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
SPLM.AxisOrientation = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical"});

SPLM.Sense = Object.freeze({
    "Forward" : "Forward", "Reverse" : "Reverse"});

SPLM.PlaneNormalOrientation = Object.freeze({
    "Inward" : "Inward", "Outward" : "Outward"});

SPLM.RotationDirection = Object.freeze({
    "RightHand" : "RightHand", "LeftHand" : "LeftHand"});

SPLM.Persistence = Object.freeze({
    "Temporary" : "Temporary", "Permanent" : "Permanent"});

SPLM.CurveParameterType = Object.freeze({
    "ArcLength" : "ArcLength", "PercentArcLength" : "PercentArcLength", "ThroughPoint" : "ThroughPoint"});

SPLM.XYZAxis = Object.freeze({
    "XAxis" : "XAxis", "YAxis" : "YAxis", "ZAxis" : "ZAxis"});

SPLM.OriginMethod = Object.freeze({
    "SpecifyPoint" : "SpecifyPoint", "WorkPartOrigin" : "WorkPartOrigin"});

export default SPLM;